import { CURRENT_LANGUAGE } from 'consts'
import { LANGUAGES_LIST } from 'consts/translations'

export const findAndGetSelectedLanguage = () =>
  LANGUAGES_LIST.find(lang => lang.code === CURRENT_LANGUAGE) ||
  LANGUAGES_LIST[0]
